<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      仓库拆分规则
    </p>
    <template slot="extra">
      <Button type="primary" icon="md-add" @click="addAction()"
        >批量导入</Button
      >
      <!-- <Button type="primary" icon="ios-link" @click="importAction()">品牌/单品映射关系</Button> -->
      <Button
        type="primary"
        icon="md-sync"
        @click="reset()"
        v-access="'splitList.reset'"
        >刷新</Button
      >
    </template>
    <Row>
      <Col span="18">
        <DatePicker
          type="month"
          placeholder="请选择月份"
          v-model="search.month"
          format="yyyyMM"
          class="public-inp"
        ></DatePicker>
        <Select
          v-model="search.wmsCode"
          placeholder="请输入仓库名称"
          filterable
          :remote-method="handleCreate1"
          @on-change="handleCreate2"
          :loading="wmsCodeLoading"
          class="public-inp"
        >
          <Option
            v-for="(option, index) in wmsCodeList"
            :value="option.wmsCode"
            :key="index"
            >{{ option.wmsName }}</Option
          >
        </Select>
        <Select
          v-model="search.areaCode"
          placeholder="请选择省份"
          class="public-inp"
        >
          <Option
            v-for="(item, i) in areaCodeList"
            :key="i"
            :value="item.code"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="search.gradeGroupCode"
          placeholder="Grade Group"
          class="public-inp"
        >
          <Option
            v-for="(item, i) in gradeGroupCodeList"
            :key="i"
            :value="item"
            >{{ item }}</Option
          >
        </Select>
      </Col>
      <Col span="6">
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'splitList.query'"
        >
        查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ (page - 1) * pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="openFn(row)">日志</a>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="pageSize"
          :current="page"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "月份",
    key: "month",
  },
  {
    title: "仓库名称",
    key: "wmsName",
  },
  //   新增
  {
    title: "送达方编码",
    key: "shipToCode",
  },
  {
    title: "仓库三方编码",
    key: "thirdPartyCode",
  },
  {
    title: "省份",
    key: "areaName",
  },

  {
    title: "Grade Group",
    key: "gradeGroupCode",
  },
  {
    title: "SKU",
    key: "erpCode",
  },
  {
    title: "数量",
    key: "skuNum",
  },
  {
    title: "修改时间",
    key: "updatetime",
  },
  {
    title: "创建时间",
    key: "createtime",
  },
  {
    title: "操作",
    slot: "action",
  },
];
export default {
  data() {
    return {
      wmsCodeList: [],
      areaCodeList: [],
      gradeGroupCodeList: [],
      wmsCodeLoading: false,
      search: {
        month: "",
        wmsCode: "",
        areaCode: "",
        gradeGroupCode: "",
      },
      page: 1,
      pageSize: 10,
      total: 0,
      columns,
      tbList: [],
      loading: false,
    };
  },
  created() {
    this.getGradeGroup();
    this.getList();
  },
  methods: {
    getGradeGroup() {
      this.$api.baseChannel({}).then((res) => {
        if (res.code == "200") {
          this.gradeGroupCodeList = res.data;
        }
      });
    },
    handleCreate1(val) {
      let data = { name: val };
      this.wmsCodeLoading = true;
      this.$api.wareVagueSearch(data).then((res) => {
        this.wmsCodeLoading = false;
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    handleCreate2() {
      let d = this.search.wmsCode;
      this.$api.spAreaSearch({ spCode: d }).then((res) => {
        if (res.code == "200") {
          this.areaCodeList = res.data;
        }
      });
    },
    getList() {
      let data = this.search;
      data.month = this.tools.yyyymm(data.month);
      data.page = this.page;
      data.pageSize = this.pageSize;
      this.loading = true;
      this.$api.splitSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      for (var i in this.search) {
        this.search[i] = "";
      }
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    addAction() {
      this.$router.replace({ path: "/splitImport" });
    },
    importAction() {
      this.$Message.success("一张关系图");
    },
    openFn(d) {
      let query = {};
      let path = "/splitDetail";
      this.$router.replace({ path, query });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/warehouse/splitList.vue